module.exports = __webpack_public_path__ + "61b252b64eb22f8b4052c7d92a946a08.svg";